module.exports = __webpack_public_path__ + "img/broken.dfa45720.jpg";